<script setup lang="ts">
import { ref } from 'vue'

const counterOptionValue = ref(0)
</script>

<template>
    <section class="section-button-select-option-value-happy">
        <button class="button-minus-option-value-happy">
            <svg
                class="svg-minus-happy"
                viewBox="0 0 15 2"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M1 1H14" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
        <p class="text-counter-option-value-happy">{{ counterOptionValue }}</p>

        <button class="button-plus-option-value-happy">
            <svg
                class="svg-plus-happy"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 8.5H16M8.5 1V16"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </button>
    </section>
</template>

<style scoped>
.section-button-select-option-value-happy {
    @apply flex items-center justify-between gap-2;
}

.button-minus-option-value-happy {
    @apply flex items-center border border-button-yellow-happy-light rounded-md p-1;
}
.svg-minus-happy {
    @apply w-4 h-4 stroke-button-yellow-happy-light;
}

.text-counter-option-value-happy {
    @apply text-text-dark-happy-light text-lg text-center w-6 font-semibold;
}

.button-plus-option-value-happy {
    @apply flex items-center bg-button-yellow-happy-light p-1 rounded-md;
}

.svg-plus-happy {
    @apply w-4 h-4 stroke-bg-happy-light;
}
</style>
